import { useState } from "react";
import { faqItems } from "@/mocks/movies";

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-[800px] mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-1">关于八戒影院的常见疑问解答</p>
        </div>
        <div className="flex flex-col gap-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-lg border border-background-200/50 overflow-hidden"
            >
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm font-medium text-foreground-900 pr-4">
                  {item.question}
                </span>
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`ri-arrow-down-s-line text-foreground-500 transition-transform duration-200 ${
                      openIdx === idx ? "rotate-180" : ""
                    }`}
                  ></i>
                </div>
              </button>
              {openIdx === idx && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}